import React, { memo } from 'react';

import { Image, Link, Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import texts from '@components/BondDirectoryFeature/feature/BondDetails/en.json';
import BondSectionTemplate from '@components/BondDirectoryFeature/feature/BondDetails/components/BondSectionTemplate';

const ContactDetails = ({ contactDetails }) => {
    return (
        <BondSectionTemplate className="border-b-0">
            <Text
                content={texts?.couldNotFind}
                className="text-gray-900 p3-semibold"
            />
            <div className="flex flex-col gap-4 xl:flex-row xl:gap-10  pb-10">
                {contactDetails?.map(
                    ({ logo, label, href, value, className }, index) => (
                        <div
                            key={index}
                            className={cn('flex gap-6 items-center', className)}
                        >
                            <div className="flex items-center gap-2">
                                <Image src={logo} alt={label} />
                                <Text
                                    content={label}
                                    className="text-gray-900 p4-medium"
                                />
                            </div>
                            <Link
                                href={href}
                                {...(href
                                    ? {
                                          target: '_blank',
                                          rel: 'noopener noreferrer',
                                      }
                                    : {})}
                            >
                                <Text
                                    content={value}
                                    className="flex-1 inline-block lowercase p3-medium text-primary-500 whitespace-nowrap"
                                />
                            </Link>
                        </div>
                    )
                )}
            </div>
        </BondSectionTemplate>
    );
};

export default memo(ContactDetails);
